import React from "react";
import Edit from "@mui/icons-material/Edit";
import PeopleOutlineOutlined from "@mui/icons-material/PeopleOutlineOutlined";

import { useSelector } from "react-redux";
import { searchFormSelector } from "redux/searchForm";

import { Stack, Typography } from "@mui/material";
import { useTranslations } from "hooks/useTranslations";
import {
  dateStringToDateObj,
  dateObjToDayDateStringShort,
  useConfig,
} from "@thekilroygroup/shared-ui";

export default function FlightDetails() {
  const { flights, tripType, passengers } = useSelector(searchFormSelector);
  const { translations } = useTranslations();
  const { locale } = useConfig();
  const translationsMobileHeader = translations.searchResultsPage.mobileHeader;

  const dateOut: Date | null =
    flights[0].departureDate !== null
      ? dateStringToDateObj(flights[0].departureDate.substring(0, 19))
      : null;

  const dateRet: Date | null =
    tripType === "RETURN" && flights[1].departureDate !== null
      ? dateStringToDateObj(flights[1].departureDate.substring(0, 19))
      : null;

  const dateOutStr = dateObjToDayDateStringShort(dateOut, locale);

  const dateReturnStr =
    tripType === "RETURN"
      ? `- ${
          dateObjToDayDateStringShort(dateRet, locale) ||
          translationsMobileHeader.dateLabel
        }`
      : "";

  const passengerCount = (passengers: Object) => {
    return Object.values(passengers).reduce((a, b) => a + b);
  };

  return (
    <Stack>
      <Stack alignItems="center" justifyContent="center" direction="row">
        <Typography
          variant="h3"
          sx={{ lineHeight: 1, textTransform: "uppercase" }}
        >
          {tripType === "MULTI_DEST"
            ? translations.search.tripTypes.OPEN_JAW
            : `${
                flights[0].departure || translationsMobileHeader.fromLabel
              } - ${flights[0].arrival || translationsMobileHeader.toLabel}`}
        </Typography>
        <Edit fontSize="small" sx={{ ml: 0.2 }} />
      </Stack>
      <Typography
        variant="titleSmall"
        sx={{ display: "flex", alignItems: "center", mx: "auto" }}
      >
        {tripType !== "MULTI_DEST" &&
          `${
            dateOutStr || translationsMobileHeader.dateLabel
          } ${dateReturnStr}`}
        <PeopleOutlineOutlined sx={{ fontSize: 13, ml: 0.7 }} />
        {passengerCount(passengers)}
      </Typography>
    </Stack>
  );
}
